import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-loading-dialog',
    styleUrls: ['./loading-dialog.component.css'],
    templateUrl: './loading-dialog.component.html',
})
export class LoadingDialogComponent {

    title: string = "Een moment geduld";
    label: string = "Verwerken...";    

    constructor(public dialogRef: MatDialogRef<LoadingDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {

        if(data.title) {
            this.title = data.title;
        }

        if(data.label) {
            this.label = data.label;
        }
    }

}